export const VEHICLE_ASSIGNMENT_MODE = Object.freeze({
  CARPOOLING: 'carpooling',
  SEPARATE_TRIP: 'separate_trip',
});

export const buildVehicleAssignmentSelection = (
  vehicle = {},
  mode = VEHICLE_ASSIGNMENT_MODE.CARPOOLING,
  currentCaptainId = 0
) => {
  const sourceTransportId = vehicle?.source_transport_id || vehicle?.transport_id || null;
  const isCarpooling = mode === VEHICLE_ASSIGNMENT_MODE.CARPOOLING;

  return {
    ...vehicle,
    source_transport_id: sourceTransportId,
    vehicle_assignment_mode: mode,
    transport_id: isCarpooling ? sourceTransportId : null,
    captain_id: isCarpooling
      ? vehicle?.captain_id || currentCaptainId
      : currentCaptainId,
  };
};

export const getVehicleSelectionReference = (row = {}) => ({
  ...row,
  transport_id: row?.source_transport_id || row?.transport_id || null,
});

export const mergeVehicleAssignmentSelection = (
  availableVehicle = null,
  selectedVehicle = null
) => {
  if (!availableVehicle) {
    return selectedVehicle;
  }
  if (!selectedVehicle) {
    return availableVehicle;
  }

  return {
    ...availableVehicle,
    ...selectedVehicle,
  };
};

export const getTransportIdForPayload = (row = {}) =>
  row?.vehicle_assignment_mode === VEHICLE_ASSIGNMENT_MODE.SEPARATE_TRIP
    ? null
    : row?.transport_id || null;

export const isSeparateTrip = (row = {}) =>
  row?.vehicle_assignment_mode === VEHICLE_ASSIGNMENT_MODE.SEPARATE_TRIP;
